import React from "react";
import { string, bool } from "prop-types";

import I18n from "pages/_components/I18n";

const EnvironmentStepper = ({ isMobile, page }) => {
    const fistStepPages = ["StepGeneralData", "StepTaxData"];
    const secondStepPages = ["StepLegalRepresentative", "StepShareholders", "StepProxies", "StepBeneficiaries"];
    const thirdStepPages = ["StepDocumentation", "StepFinish", "StepError"];
    const fourthStepPages = ["StepAcceptPayway", "StepSelectPaywayTerminalType"];
    const fifthStepPages = ["StepSelectPaywayCategory", "StepPaywayTerminals", "StepFinishPayway"];

    let currentStep = 0;
    if (fistStepPages.includes(page)) {
        currentStep = 1;
    }
    if (secondStepPages.includes(page)) {
        currentStep = 2;
    }
    if (thirdStepPages.includes(page)) {
        currentStep = 3;
    }
    if (fourthStepPages.includes(page)) {
        currentStep = 4;
    }
    if (fifthStepPages.includes(page)) {
        currentStep = 5;
    }

    const stepTitles = {
        0: "Error",
        1: "Datos de la empresa",
        2: "Estructura societaria",
        3: "Carga de documentación",
        4: "Tipo de negocio",
        5: "Datos generales",
    };

    const defaultColor = "var(--primary-background-color)";
    const activeColor = "var(--details-details-color)";

    const mobileBoxStyle = {
        display: "flex",
        justifyContent: "space-between",
    };

    const stepNumber = currentStep > 3 ? currentStep - 3 : currentStep;

    const mobileBarStyle = (numOfBar) => ({
        width: currentStep < 4 ? "32%" : "48%",
        borderRadius: 6,
        height: 6,
        marginBottom: 10,
        backgroundColor: stepNumber >= numOfBar ? activeColor : defaultColor,
    });

    const desktopBarStyle = (numOfBar) => ({
        height: 70,
        borderRadius: 6,
        width: 6,
        marginRight: 10,
        backgroundColor: stepNumber >= numOfBar ? activeColor : defaultColor,
    });

    const desktopTextStyle = (numOfStep) => {
        let textColor = "var(--color-grey)";
        if (stepNumber >= numOfStep) {
            textColor = "var(--primary-active-color)";
        } else if (stepNumber === numOfStep) {
            textColor = "var(--primary-link-color)";
        }

        return {
            fontWeight: stepNumber === numOfStep ? "bold" : "normal",
            color: textColor,
        };
    };

    if (currentStep < 4) {
        return isMobile ? (
            <div className="stepper">
                <div style={mobileBoxStyle}>
                    <div style={mobileBarStyle(1)} />
                    <div style={mobileBarStyle(2)} />
                    <div style={mobileBarStyle(3)} />
                </div>
                <div style={{ color: "var(--primary-active-color)" }}>
                    <span>{`Paso ${currentStep}: ${stepTitles[currentStep]}`}</span>
                </div>
            </div>
        ) : (
            <div className="stepper">
                <I18n id="legalPerson.title" defaultValue="Registro" component="h2" />
                <div className="step-item flex mt-10">
                    <div style={desktopBarStyle(1)} />
                    <div style={desktopTextStyle(1)}>
                        <I18n defaultValue="Paso" />
                        <span>{` 1:`}</span>
                        <p>{stepTitles[1]}</p>
                    </div>
                </div>
                <div className="step-item">
                    <div style={desktopBarStyle(2)} />
                    <div style={desktopTextStyle(2)}>
                        <I18n defaultValue="Paso" />
                        <span>{` 2:`}</span>
                        <p>{stepTitles[2]}</p>
                    </div>
                </div>
                <div className="step-item">
                    <div style={desktopBarStyle(3)} />
                    <div style={desktopTextStyle(3)}>
                        <I18n defaultValue="Paso" />
                        <span>{` 3:`}</span>
                        <p>{stepTitles[3]}</p>
                    </div>
                </div>
            </div>
        );
    }

    return isMobile ? (
        <div className="stepper">
            <div style={mobileBoxStyle}>
                <div style={mobileBarStyle(1)} />
                <div style={mobileBarStyle(2)} />
            </div>
            <div style={{ color: "var(--primary-active-color)" }}>
                <span>{`Paso ${stepNumber}: ${stepTitles[currentStep]}`}</span>
            </div>
        </div>
    ) : (
        <div className="stepper">
            <I18n id="legalPerson.title" defaultValue="Registro" component="h2" />
            <div className="step-item flex mt-10">
                <div style={desktopBarStyle(1)} />
                <div style={desktopTextStyle(1)}>
                    <I18n defaultValue="Paso" />
                    <span>{` 1:`}</span>
                    <p>{stepTitles[4]}</p>
                </div>
            </div>
            <div className="step-item">
                <div style={desktopBarStyle(2)} />
                <div style={desktopTextStyle(2)}>
                    <I18n defaultValue="Paso" />
                    <span>{` 2:`}</span>
                    <p>{stepTitles[5]}</p>
                </div>
            </div>
        </div>
    );
};

EnvironmentStepper.propTypes = {
    isMobile: bool.isRequired,
    page: string.isRequired,
};

export default EnvironmentStepper;
